/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Self_Organized_RoundsInputs */



/**
* | output |
* | --- |
* | "Self-organized rounds" |
*
* @param {Tfield_Self_Organized_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_self_organized_rounds = /** @type {((inputs?: Tfield_Self_Organized_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Self_Organized_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes auto-organisées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas autoorganizadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas Auto-organizadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round autogestiti")
	return /** @type {LocalizedString} */ ("Self-organized rounds")
});